"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BeautifulImageElement() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="красив-снимков-елемент" className="container relative py-20 md:py-32 overflow-hidden bg-background">
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1504672/img/food_pattern.png)] bg-cover bg-center bg-no-repeat opacity-5 pointer-events-none"></div>
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-secondary/5 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full opacity-[0.03] bg-[radial-gradient(#E94E3A_1px,transparent_1px)] [background-size:20px_20px]" />
      </div>

      <div ref={ref} className={`relative z-10 transition-all duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-3 scale-95"}`}>
        <div className="max-w-sm mx-auto">
          <h2 className="font-display text-[32px] leading-[1.25] font-bold tracking-[0.02em] text-center mb-8">
            Днешното ни Специално Меню
          </h2>
          <div className="relative overflow-hidden rounded-3xl border-4 border-foreground shadow-medium">
            <img src="https://mishmashinterpred.com/wp-content/uploads/2026/05/686964377_122193458852790872_8372511250967385966_n.webp" alt="Дневно меню" className="w-full h-full object-contain transition-transform duration-[var(--duration-medium)] hover:scale-[1.02]" />
          </div>
          <p className="mt-4 text-center text-sm font-medium text-muted-foreground italic">Разнообразно меню всеки ден. За Вас.</p>
        </div>
      </div>
    </section>;
}